import { Button } from '@ui-kit/MyButton';
import classNames from 'classnames';
import { useState, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { scrollToElement } from '@shared/helpers';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { IPopup } from './TypeProps';
import { ElementIdTab, getProductTabs, productActions, TabTitle } from '@entities/Product';

import styles from './PopupRemainder.module.scss';

export const PopupRemainder = ({ text, className, part, max, onClose }: IPopup) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const isMobile = useWindowSizing(320);
  const tabList = useAppSelector(getProductTabs);

  const handleOpenModal = () => {
    setIsOpen(!isOpen);
    onClose();
  };

  const handleOpenAnalogues = useCallback(() => {
    dispatch(productActions.setActiveTab(tabList.findIndex(tab => tab.title === TabTitle.Analogues)));
    scrollToElement(document?.getElementById(ElementIdTab.TabAnalogues), {
      scrollIntoView: isMobile,
    });
  }, [tabList]);

  return (
    <>
      {isOpen && (
        <div className={classNames(styles.Wrapper, className)} onClick={handleOpenModal}>
          {text}
          {part === 11 && max < 4 && (
            <Button className={styles.BtnAnalog} onClick={handleOpenAnalogues} themes={'Violet'}>
              Смотреть аналоги
            </Button>
          )}
        </div>
      )}
    </>
  );
};
